import React from 'react';
import { Container, Text } from 'basis';

export function AdditionalIncomeSectionHeading() {
  return (
    <Container margin="6 0 4 0">
      <hr style={{ border: 0, borderTop: '1px solid #e6e6e6', margin: '0 0 24px 0' }} />
      <Text as="h4" textStyle="heading4">
        Your additional income
      </Text>
    </Container>
  );
}
